import React, { useEffect } from "react";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import Margin from "canvas-core-react/lib/Margin";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Card from "canvas-core-react/lib/Card";
import { ScotiamanAvatar } from "../../components/scotiamanAvatar";
import { default as config } from "../../mocks/coach-financiero-config.json";
import { Step } from "../../components/step";
import "./style.scss";
import { tagCoach } from "../../utils/utils";

export const CoachView = () => {
  useEffect(() => {
    tagCoach("1", "", "inicio-flujo", "1");
  }, []);

  return (
    <>
      <Margin xs={12} sm={12} md={12} lg={12}>
        <Row>
          <Column lgOffset={1} lg={11}>
            <img
              alt="scotiabank-logo"
              className="coachView__scotiabank-logo"
              src={`https://scotiabankfiles.azureedge.net/scotiabank-chile/Scotia.png`}
            />
          </Column>
        </Row>
      </Margin>
      <Row className="coachView">
        <div className="coachView__banner">{""}</div>
      </Row>
      <Row justifyContent="center" className="coachView__coachman">
        <Column xs={3} sm={5} md={7} lg={7}>
          <Card className="coachView__coachman__card">
            <Row justifyContent="center">
              <ScotiamanAvatar />
            </Row>
            <Margin xs={6} sm={6} md={6} lg={6}>
              <Row justifyContent="center">
                <TextSubtitle component="span">
                  Un Coach que fortalecerá tu condición financiera.
                </TextSubtitle>
              </Row>
            </Margin>
            <Row justifyContent="center">
              <TextBody component="span">
                Conocer tu condición financiera es el primer paso para ponerte en forma.
              </TextBody>
            </Row>
            <Row>
              <Column xs={4} sm={8} md={12} lg={12}>
                {
                  <div id="content">
                    <Step steps={config} step={config[0].step} />
                  </div>
                }
              </Column>
            </Row>
          </Card>
        </Column>
      </Row>
    </>
  );
};
